export const isValidUrl = (url: string): boolean => {
    try {
        /** If this doesn't throw then we can assume that the url is valid  */
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
};
